import { render, staticRenderFns } from "./CustomerLeftSidebar.vue?vue&type=template&id=4c53f636"
import script from "./CustomerLeftSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports